import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';
import { Github, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <div>
            {/* Newsletter Section */}
            <section className="newsletter-section">
                <div className="newsletter-container">
                    <div className="newsletter-content">
                        <h2>Stay Updated</h2>
                        <p>Get the latest product updates and company news delivered to your inbox.</p>
                    </div>
                    <form className="newsletter-form">
                        <input type="email" className="newsletter-input" placeholder="Enter your email" required />
                        <button type="submit" className="subscribe-btn">Subscribe</button>
                    </form>
                </div>
            </section>

            {/* Main Footer */}
            <footer className="main-footer">
                <div className="footer-container">
                    <div className="footer-grid">
                        {/* Brand Column */}
                        <div className="footer-brand">
                            <div className="footer-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                                <svg
                                    className="product-icon"
                                    viewBox="0 0 100 100"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M 20 35 L 45 35"
                                        stroke="#1E40AF"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                    ></path>
                                    <path
                                        d="M 20 50 L 55 50"
                                        stroke="#14B8A6"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                    ></path>
                                    <path
                                        d="M 20 65 L 65 65"
                                        stroke="#F59E0B"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                    ></path>
                                    <path d="M 45 35 L 55 40 L 45 45 Z" fill="#1E40AF"></path>
                                    <path d="M 55 50 L 65 55 L 55 60 Z" fill="#14B8A6"></path>
                                    <path d="M 65 65 L 75 70 L 65 75 Z" fill="#F59E0B"></path>
                                    <circle cx="80" cy="50" r="8" fill="#1E40AF"></circle>
                                </svg>
                                <span className="logo-text">SequFlow</span>
                            </div>
                            <p className="footer-description">
                                Complete suite of enterprise and consumer products — unified design, consistent experience, built for scale.
                            </p>
                            <div className="social-links">
                                <button className="social-link" aria-label="GitHub">
                                    <Github size={18} />
                                </button>
                                <button className="social-link" aria-label="Twitter">
                                    <Twitter size={18} />
                                </button>
                                <button className="social-link" aria-label="LinkedIn">
                                    <Linkedin size={18} />
                                </button>
                            </div>
                        </div>

                        {/* Features Column */}
                        <div className="footer-column">
                            <h3>Products</h3>
                            <ul className="footer-links">
                                <li><button onClick={() => navigate('/task-management')}>Task Management</button></li>
                                <li><button>Core suite</button></li>
                                <li><button>Vertical Solutions</button></li>
                                <li><button>Daliy APPa</button></li>
                                <li><button>SequMail</button></li>
                                <li><button>SequConnect</button></li>
                                <li><button>SequHub</button></li>
                            </ul>
                        </div>

                        {/* Resources Column */}
                        <div className="footer-column">
                            <h3>Company</h3>
                            <ul className="footer-links">
                                <li><button>About Us</button></li>
                                <li><button>Careers</button></li>
                                <li><button>Case Studies</button></li>
                                <li><button>Support</button></li>
                               
                            </ul>
                        </div>

                        {/* Explore Column */}
                        <div className="footer-column">
                            <h3>Legal & Compliance
            
                            </h3>
                            <ul className="footer-links">
                                <li><button>Terms of service</button></li>
                                <li><button>Privacy Policy</button></li>
                                <li><button>Cookie Policy</button></li>
                                <li><button>GDPR</button></li>
                                <li><button>Trademark Policy</button></li>
                               
                            </ul>
                        </div>

                        {/* Compare Column */}
                        <div className="footer-column">
                            <h3>Security & Safety</h3>
                            <ul className="footer-links">
                                <li><button>Security Policy</button></li>
                                <li><button>lPR Complaints</button></li>
                                <li><button>Anti Spam Policy</button></li>
                                <li><button>Compliance</button></li>
                                <li><button>Abuse Policy</button></li>
                             
                            </ul>
                        </div>

                        {/* Legal Column */}
                        <div className="footer-column">
                            <h3>Legal & Compliance</h3>
                            <ul className="footer-links">
                                <li><button>Terms of Service</button></li>
                                <li><button>Privacy Policy</button></li>
                                <li><button>Cookie Policy</button></li>
                                <li><button>GDPR</button></li>
                                <li><button>Security Policy</button></li>
                                <li><button>IPR Complaints</button></li>
                                <li><button>Abuse Policy</button></li>
                            </ul>
                        </div>
                    </div>

                    {/* Footer Bottom */}
                    <div className="footer-bottom">
                        <div className="copyright">
                            © 2026 SequFlow Pvt. Ltd. All Rights Reserved.
                        </div>
                        <div className="footer-bottom-links">
                            <button>Sitemap</button>
                            <button>Accessibility</button>
                            <button>Status</button>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
